import { Badge, cn } from '@startupquickstart/frontend';

interface StatusBadgeProps {
  /** Linear workflow state: `name`, `type` (backlog|started|completed|...), color hex. */
  state: { name: string; type: string; color?: string };
  className?: string;
}

const TYPE_CLASS: Record<string, string> = {
  triage: 'bg-amber-100 text-amber-800',
  backlog: 'bg-slate-100 text-slate-700',
  unstarted: 'bg-blue-100 text-blue-800',
  started: 'bg-indigo-100 text-indigo-800',
  completed: 'bg-emerald-100 text-emerald-800',
  canceled: 'bg-zinc-100 text-zinc-600',
};

/**
 * Status pill for a Linear ticket state. Maps Linear's state `type`
 * (canonical workflow stage) to a colour rather than relying on the
 * arbitrary state name, so renamed columns ("In Review" → "Reviewing")
 * keep their visual identity.
 */
export function StatusBadge({ state, className }: StatusBadgeProps) {
  return (
    <Badge
      variant="outline"
      className={cn(TYPE_CLASS[state.type] ?? '', className)}
    >
      {state.name}
    </Badge>
  );
}
